const r = (e) => Object.entries(e).map(([t, o]) => `${t.replace(/([A-Z])/g, "-$1").toLowerCase()}: ${o}`).join("; ");
export {
  r as convertStyleObjectToCss
};
